import {LayerManagerV24} from '@volkswagen-onehub/layer-manager'
import React from 'react'
import {Provider} from 'react-redux'
import store from '../../store'
import {LegalNotesLayer} from '../LegalNotesLayer'

function disclaimerLayer(): React.JSX.Element {
    return (
        <Provider store={store}>
            <LegalNotesLayer />
        </Provider>
    )
}

let localLayerManager: LayerManagerV24
let layer: {close: () => void}

export const setDisclaimerLayerHandle = (layerManager: LayerManagerV24) => {
    localLayerManager = layerManager
}

export const openDisclaimerLayer = () => {
    layer = localLayerManager.openContentLayerV2(
        disclaimerLayer,
        {},
        {
            'aria-labelledby': 'legal-notes-layer-title',
            'closeButtonLabel': 'Chiudi',
            'contentHeadline': 'Note legali',
        }
    )
}

export const closeDisclaimerLayer = () => {
    if (layer) {
        layer.close()
    }
}
